import { MarcheReconductionInput } from '../../../../openapi/build';
import { DateUtils } from '../services/date-utils';

export class MarcheReconduction {
  constructor(
    public uuid: string,
    public numero: string | null,
    public dateDebut: Date | null,
    public dateFin: Date | null,
    public seuilMinimum: number,
    public seuilMaximum: number,
    public montantEngage?: number,
    public montantEngagePrev?: number
  ) {}

  static adapt(item: any): MarcheReconduction {
    return new MarcheReconduction(
      item.uuid,
      item.numero,
      item.dateDebut ? item.dateDebut : null,
      item.dateFin ? item.dateFin : null,
      item.seuilMinimum,
      item.seuilMaximum,
      item.montantEngage,
      item.montantEngagePrev
    );
  }

  static toMarcheReconductionInput(formValue: any): MarcheReconductionInput {
    return {
      dateDebut: DateUtils.localDateToApiString(formValue.dateDebut),
      dateFin: DateUtils.localDateToApiString(formValue.dateFin),
      seuilMinimum: formValue.seuilMinimum ?? 0,
      seuilMaximum: formValue.seuilMaximum ?? 0
    };
  }
}
